// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedPaymentProfileEntryStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

savedPaymentProfileEntryStyles.container = {
    css: css`
        margin-top: 12px;
    `,
};

savedPaymentProfileEntryStyles.hintContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 4px;
        width: 100%;
        & + span {
            display: none;
        }
    `,
};

savedPaymentProfileEntryStyles.hintLink = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};
